export default "__VITE_ASSET__C16nIsej__"